import { render, staticRenderFns } from "./productsCreationModal.vue?vue&type=template&id=178d2f13"
import script from "./productsCreationModal.vue?vue&type=script&lang=js"
export * from "./productsCreationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports